import React, { SyntheticEvent, useEffect, useState } from 'react'
import { gf } from '../api/giphy';
import { IGif } from '@giphy/js-types';
import { Gif } from '@giphy/react-components';


interface GifMessageProps {
  gifId: string;
  author: string;
}

const GifMessage: React.FC<GifMessageProps> = ({ gifId, author }) => {
  const [gifData, setGifData] = useState<IGif | null>(null);


  useEffect(() => {
    const fetchGifData = async () => {
      const { data } = await gf.gif(gifId);
      setGifData(data);
    }
    fetchGifData();
  }, [gifId]);

  const handleGifClick = (gif: IGif, e: SyntheticEvent<HTMLElement, Event>) => {
    e.preventDefault();
  }

  return gifData && (
    <div className="bg-black bg-opacity-20 p-1">
      <p className="font-mono">{author}:</p>
      <Gif
        className='opacity-80 cursor-default'
        width={300}
        gif={gifData}
        onGifClick={handleGifClick}
      />
    </div>
  );
}

export default GifMessage;
